export default `
@import url('https://fonts.googleapis.com/css?family=Audiowide|Mrs+Saint+Delafield');

body {
  font-family: Audiowide, sans-serif;
}
`
